import { useNavigate } from "react-router-dom";
import CardSectionNotOnClick from "../design/CardSectionNotOnClick";
import CardText from "../design/CardText";
import Logo from "../design/Logo";

const Notice = () => {
  const textArray = ["보", "카", "톡", "톡"];
  const navigate = useNavigate();
  const cardData = {
    title: "",
    items: [
      "'보카톡톡'은 자동 메타인지를 적용한 특허받은 학습 로직을 통해 학습자에게 최적화된 맞춤형 학습을 제공합니다.",
      "이 시스템은 학습자가 아는 단어와 모르는 단어를 자동으로 분류하고, 학습 과정에서 자주 틀린 단어를 집중적으로 연습하고 테스트하여 쉽게 장기 기억으로 전환하도록 돕습니다.",
      "또한, 학습자의 능력치에 따라 학습 방법이 자동으로 조정되어 경계선에 있는 학생들도 효과적인 학습 결과를 얻을 수 있도록 설계되었습니다.",
      "이러한 혁신적인 로직을 통해 '보카톡톡'은 모든 학습자에게 학습 결과를 보장합니다.",
      "또한, 테스트나 연습할 때 즐겁게 학습할 수 있도록 다양한 테스트를 구현합니다.",
    ],
  };

  const onCooperateClick = () => {
    navigate("/fun_learning/cooperate");
  };

  const onSuccessedwordsClick = () => {
    navigate("/fun_learning/successedwords");
  };

  const onLiteracyLearning = () => {
    navigate("/fun_learning/literacylearning");
  };

  return (
    <section className="bg-gray-200 dark:bg-gray-700">
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="mb-4 text-3xl sm:text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            보카톡톡의 모든 것!
          </h2>

          <div>
            {" "}
            <a
              href="https://rose-whip-1fa.notion.site/773e2cddf58a4e31b943460c1a619372?pvs=4"
              target="_blank"
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-green-600 to-green-500 hover:bg-gradient-to-b dark:shadow-green-900 shadow-green-200 hover:shadow-2xl hover:shadow-green-400 hover:-tranneutral-y-px "
            >
              공지사항 바로가기
            </a>
          </div>
          <div>
            <button
              onClick={onCooperateClick}
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-blue-600 to-blue-500 hover:bg-gradient-to-b dark:shadow-blue-900 shadow-blue-200 hover:shadow-2xl hover:shadow-blue-400 hover:-tranneutral-y-px "
            >
              협력학습실로 이동하기!
            </button>
          </div>
          <div>
            {" "}
            <a
              href="https://chamstudyland.com/vokok/desktop/login.php"
              target="_blank"
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-orange-600 to-orange-500 hover:bg-gradient-to-b dark:shadow-orange-900 shadow-orange-200 hover:shadow-2xl hover:shadow-orange-400 hover:-tranneutral-y-px "
            >
              보카톡톡 학습하러가기!
            </a>
          </div>
          <div>
            <a
              href="https://chamstudyland.com/vokok/desktop/test_sentence.php"
              target="_blank"
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-purple-600 to-purple-500 hover:bg-gradient-to-b dark:shadow-purple-900 shadow-purple-200 hover:shadow-2xl hover:shadow-purple-400 hover:-tranneutral-y-px "
            >
              문장톡톡 학습하러가기!
            </a>
          </div>
          <div>
            <button
              onClick={onLiteracyLearning}
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-amber-600 to-amber-500 hover:bg-gradient-to-b dark:shadow-amber-900 shadow-amber-200 hover:shadow-2xl hover:shadow-amber-400 hover:-tranneutral-y-px "
            >
              기초학습 학습하러가기!
            </button>
          </div>
          <div>
            <button
              onClick={onSuccessedwordsClick}
              className="mt-3 font-bold inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-pink-600 to-pink-500 hover:bg-gradient-to-b dark:shadow-pink-900 shadow-pink-200 hover:shadow-2xl hover:shadow-pink-400 hover:-tranneutral-y-px "
            >
              성공한 단어 학습하기!
            </button>
          </div>
        </div>
        <Logo textArray={textArray} />
        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
          <h2 className="pt-10 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            다같이 보카톡톡!
          </h2>
        </div>

        <CardText title={cardData.title} items={cardData.items} />
      </div>
    </section>
  );
};

export default Notice;
